/* ––
 * ––– Imports
 * –––––––––––––––––––––––––––––––– */
import Header from 'components/Layout/Header';
import Footer from 'components/Layout/Footer';
import CompanyBanner from 'components/Layout/Banner';
import { Iterable } from 'immutable';

import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';

import PropTypes from 'prop-types';
import React from 'react';

import Article from './Article';
import Content from './Content';

/* ––
 * ––– Component
 * –––––––––––––––––––––––––––––––– */
function Main({ company }) {
  /* –– Render
   * –––––––––––––––––––––––––––––––– */
  return (
    <>
      <header>
        <Header name={company.name} logo={company.logo} />
      </header>

      <main id="top" data-testid="page-main-section">
        {/* Banner */}
        <CompanyBanner imageUrl={company.listingsBanner} />

        {/* Header title */}
        <Container>
          <Box sx={{ display: 'flex', justifyContent: 'center', pt: 3 }}>
            <Typography variant="h2" sx={{ fontWeight: 'bold' }}>
              {company.parameters.listingsHeader || t('eos.company.listings.page.label.default_header', { company: company.name })}
            </Typography>
          </Box>
        </Container>

        <Content locale={company.locale} />
      </main>

      <article>
        <Article name={company.name} description={company.description} />
      </article>
      <footer>
        <Footer name={company.name} logo={company.logo} goTopTarget="top" />
      </footer>
    </>
  );
}

/* ––
 * ––– Props declaration
 * –––––––––––––––––––––––––––––––– */
Main.propTypes = {
  company: PropTypes.objectOf(Iterable),
};

Main.defaultProps = {
  company: null,
};

/* ––
 * ––– Exports
 * –––––––––––––––––––––––––––––––– */
export default Main;
